/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../Images/Logo.svg";
import { HiMenu } from "react-icons/hi";
import { adminDashboardData } from "../../Data/Data";

const AdminSidebar = () => {
  const [toggle, setToggle] = useState(false);

  const toggleHandler = () => {
    setToggle(!toggle);
  };

  return (
    <div
      style={{ width: toggle ? "250px" : "50px" }}
      className="sticky top-0 bottom-0 w-[250px] h-[100vh] shadow-xl"
    >
      <div className="flex justify-between items-center  px-1  mt-6">
        <div style={{ display: toggle ? "flex" : "none" }} className="w-[80px]">
          <img src={Logo} alt="" className="w-full" />
        </div>
        <div className="cursor-pointer" onClick={toggleHandler}>
          <HiMenu className="text-3xl text-black" />
        </div>
      </div>

      <div
        style={{ display: toggle ? "block" : "none" }}
        className="mx-3 mt-6 mb-3 text-black font-semibold text-xl"
      >
        Hi, Admin
      </div>

      {/* <div className="flex justify-center px-1 items-start mt-4 ">
        <NavLink
          to="service-request"
          className="p-2 w-full rounded-lg flex justify-start items-center gap-4 transition-all text-black hover:text-white hover:bg-navBg"
        >
          <p
            className="lg:flex font-Poppins font-semibold"
            style={{ display: toggle ? "flex" : "none" }}
          >
            Service Requested
          </p>
          <div
            style={{ fontSize: toggle ? "23px" : "25px" }}
            className="relative text-xl group-hover:text-white"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 24 24"
            >
              <path
                fill="black"
                d="M21 8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1.062A8.001 8.001 0 0 1 12 23v-2a6 6 0 0 0 6-6V9A6 6 0 0 0 6 9v7H3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.062a8.001 8.001 0 0 1 15.876 0zM7.76 15.785l1.06-1.696A5.972 5.972 0 0 0 12 15a5.972 5.972 0 0 0 3.18-.911l1.06 1.696A7.963 7.963 0 0 1 12 17a7.962 7.962 0 0 1-4.24-1.215"
              />
            </svg>
          </div>
        </NavLink>
      </div> */}

      <div className=" flex flex-col justify-center items-start gap-6 mt-8 px-1 ">
        {adminDashboardData?.map((item) => (
          <NavLink
            to={item.path}
            key={item.id}
            id="activeLink"
            className="p-2 w-full rounded-lg flex justify-start items-center gap-4 transition-all text-black hover:text-white hover:bg-navBg"
          >
            <div
              style={{ display: toggle ? "flex" : "none" }}
              className="hidden lg:flex font-Poppins font-semibold"
            >
              {item.name}
            </div>
            <div
              style={{ fontSize: toggle ? "20px" : "25px" }}
              className="relative text-xl"
            >
              {item.icon}
            </div>
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default AdminSidebar;
